/**
 * My work — copy for the Business Hub's "My work" tab (GET /api/my-work).
 *
 * Its own slice rather than more lines in en.ts: that file is a merge hotspot
 * already close to the 500-line ceiling. Composed into `en` in ./en.ts.
 */
export const enMyWork = {
  // Business Hub tab-bar labels for the two tabs this slice covers. Resolved at
  // render, not at module scope — SYSTEM_TABS is built before setLocale runs.
  'hubTab.work': 'My work',
  'hubTab.team': 'Team',

  'myWork.title': 'My work',
  'myWork.subtitle':
    'Board rows and chat tasks assigned to you — soonest first.',

  // States
  'myWork.loading': 'Loading your work…',
  'myWork.loadFailed': "Couldn't load your work.",
  'myWork.retry': 'Try again',
  'myWork.empty': 'Nothing is assigned to you right now.',
  'myWork.emptyHint':
    'Assign a board row to yourself, or promote a chat message to a task — then it shows up here.',
  'myWork.emptyFiltered': 'Nothing to do in this filter.',
  'myWork.ctaBoards': 'Open boards',
  'myWork.ctaChat': 'Open Workspace',

  // Source filters
  'myWork.source.board': 'Board rows',
  'myWork.source.chat': 'Chat tasks',

  // Due-date buckets. Undated work is not overdue and not upcoming — it is
  // work with no deadline, and it says so.
  'myWork.bucket.overdue': 'Overdue',
  'myWork.bucket.today': 'Due today',
  'myWork.bucket.upcoming': 'Upcoming',
  'myWork.bucket.undated': 'No due date',
  'myWork.undated': 'No due date',

  // Row actions
  'myWork.open': 'Open',
  'myWork.loadMore': 'Load more',
  'myWork.loadingMore': 'Loading…',
} as const;

export default enMyWork;
